query groups($teamId:ID!, $tz: String, $forCurrent: Boolean) {
  groups(teamId:$teamId, forCurrent: $forCurrent) {
    id
    name
    studentCount
    order
    orderNumerator
    deletedAt(tz: $tz)
    deletingTeacher {
      id
      first
      last
    }
    icon {
      id
      name
      displayName
    }
    color {
      id
      name
      displayName
    }
    orderDenominator
    students {
      id
      first
      last
    }
  }
}
